<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="apps"
      :pagination-options="paginationOptions"
      :sort-options="sortOptions"
      @on-page-change="onPaginationChangeFunc"
      @on-per-page-change="onPaginationChangeFunc"
      @on-sort-change="onSortChangeFunc"
      styleClass="vgt-table condensed app-table"
    >
      <template slot="table-column" slot-scope="props">
        <span>{{props.column.label}}</span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'favorite'">
          <font-awesome-icon class="table-fav-icon" v-if="props.row.isFavorite" @click="removeFavorite(props.row)" :icon="['fas', 'star']" title="Remove from favorites"/>
          <font-awesome-icon class="table-fav-icon" v-else @click="addFavorite(props.row)" :icon="['far', 'star']" title="Add to favorites"/>
        </span>
        <span v-if="props.column.field == 'title'">
          <div class="media" style="min-width: 150px;">
            <img ref="appImg" style="max-width: 20px; max-height: 20px;"
              class="align-self-start mr-3"
              @error="onImageLoadFailure($event)"
              v-bind:src="getAppIcon(props.row)">
            <div class="media-body">
              <router-link class="mt-0" title="View details" :to="'/view-app/'+props.row.id">{{props.row.title}}</router-link>
            </div>
          </div>
        </span>
        <span v-else-if="props.column.field =='type'">
          <span style="text-transform: capitalize">{{props.row.type}}</span>
        </span>
        <span v-else-if="props.column.field =='root_link'">
          <a
            v-if="props.row.root_link.type == CONSTANTS.ROOT_LINK_TYPES.LINK"
            class="btn btn-link table-btn"
            :href="props.row.root_link.reference.link"
            :target="props.row.root_link.reference.action ? props.row.root_link.reference.action : '_blank'"
            @click="setModel(props.row); openRootLink(props.row, currentRoute)"
          >{{props.row.root_link.title}}</a>
          <button
            v-else-if="!props.row.downloadData.isDownloading && !props.row.downloadData.downloadReady"
            type="button"
            class="btn btn-link table-btn"
            :href="props.row.root_link.reference.link"
            @click="setModel(props.row); openRootLink(props.row, currentRoute)"
          >{{props.row.root_link.title}}</button>
          <router-link
            v-else
            title="View details"
            :to="'/view-app/'+props.row.id"
          >{{props.row.downloadData.stateText}}</router-link>
        </span>
        <span v-else-if="props.column.label =='Entitlement'">
          <entitlement-display :app="props.row" :truncate="15"></entitlement-display>
          <!-- <span v-if="hasEntitlementType(props.row) && props.row.access.display_type === 'html'"
            v-html="props.row.access.state"></span>
          <p v-else v-bind:title="parseEntitlementString(props.row.access.state)">{{parseEntitlementString(props.row.access.state) | truncate(15)}} </p> -->
        </span>
        <span v-else-if="props.column.field =='access.last_accessed'">
          <span class="table-no-access-container" v-if="hasNoAccess(props.row)">
            <font-awesome-icon style="width: 7px; height: 16px; margin-right: 4px;" icon="circle"/>
            <p v-if="hasLastAccess(props.row)" class="access-text">{{props.row.access.last_accessed | timestampToDate}}</p>
            <p v-else class="access-text">No access</p>
          </span>
          <span class="table-access-container" v-else-if="userHasAccess(props.row)">
            <font-awesome-icon style="width: 7px; height: 16px; margin-right: 4px;" icon="circle"/>
            <p v-if="hasLastAccess(props.row)" class="access-text">{{props.row.access.last_accessed | timestampToDate}}</p>
            <p v-else class="access-text">Access</p>
          </span>
          <span class="table-last-access-container" v-else-if="hasLastAccess(props.row)">
            <font-awesome-icon style="width: 7px; height: 16px; margin-right: 4px;" icon="circle"/>
            <p class="access-text">{{props.row.access.last_accessed | timestampToDate}}</p>
          </span>
          <p v-else class="unknown-access-text">-</p>
        </span>
        <span v-else>{{props.formattedRow[props.column.field]}}</span>
      </template>
    </vue-good-table>
    <download-modal
      :model="downloadModel"
      :viewId="CONSTANTS.VIEW_IDS.DOWNLOAD_VIEW_ID"
      v-if="downloadModel && downloadModel.root_link.type === CONSTANTS.ROOT_LINK_TYPES.DIRECT_DOWNLOAD"
      v-show="downloadModel && downloadModel.show"
      @close="downloadModel = null"
    />
    <access-request-modal
        v-if="displayAccessRequestModal"
        :model="accessModel"
        :linkData="accessModel.root_link"
        @close="closeAccessRequestModal"
      />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import util from "@/util";
import api from "@/api"
import { VueGoodTable } from "vue-good-table";
import * as CONSTANTS from "../constants.js";
import AppHandlerMixin from "@/mixins/AppHandlerMixin";
import EntitlementDisplay from '@/components/EntitlementDisplay'
import phImage from "@/assets/app_placeholder.png"

export default {
  name: "AppTable",
  components: {
    VueGoodTable,
    EntitlementDisplay
  },
  props: {
    apps: Array,
    columns: Array,
    paginationOptions: Object,
    sortOptions: {
      type: Object,
      default: function() {
        return {
          enabled: true,
          initialSortBy: { field: "title", type: "asc" }
        };
      }
    },
    onPaginationChangeFunc: { type: Function, default: function() {} },
    onSortChangeFunc: { type: Function, default: function() {} }
  },
  mixins: [AppHandlerMixin],
  data: function() {
    return {
      CONSTANTS,
      downloadModel: null,
      accessModel: null,
      currentRoute: this.$router.currentRoute.path
    };
  },
  computed: {
    ...mapGetters([
      "getViewType",
      "getApplications",
      "getApplicationById",
      "getPreviousAllTablePage",
      "getPreviousAllTablePerPage"
    ])
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(["addAlert"]),
    onImageLoadFailure (event) {
      event.target.src = phImage     
    },
    setModel(model) {
      let tmp = this.getApplicationById(model.id);
      this.downloadModel = tmp
      this.accessModel = tmp
      this.downloadModel.show = true
    },
    async addFavorite(model) {
      model.isFavorite = true

      try {
        let data = {
          appId : model.id
        }
        await api.postFavorite(data)
        let app =  this.getApplicationById(model.id);
        app.isFavorite = true
      } catch (err) {
        console.log("Error adding favorite", err)
        this.addAlert(util.createAlert('',CONSTANTS.ERROR_MSGS.FAVORITES_ERROR,CONSTANTS.ALERT_CONTEXT.DANGER));
        model.isFavorite = false
      }

    },
    async removeFavorite(model) {
      model.isFavorite = false
      
      try {
        await api.deleteFavorite(model.id)
        let app =  this.getApplicationById(model.id);
        app.isFavorite = false
      } catch (err) {
        console.log("Error deleting favorite", err)
        this.addAlert(util.createAlert('',CONSTANTS.ERROR_MSGS.FAVORITES_ERROR,CONSTANTS.ALERT_CONTEXT.DANGER));
        model.isFavorite = true
      }

    }
  }
};
</script>
<style>

</style>
